<div class="d-flex flex-column">
  <span class="bold text-uppercase">{{ 'pages.transport.detail-page.events.resolution-status-change' | translate }}</span>

  @if (harmonizedEvent()) {
    <div class="fs-5 bold">{{ harmonizedEvent() }}</div>
  }

  @if (technicalInfo()) {
    <span class="text-muted" CopyOnHover>{{ technicalInfo() }}</span>
  }

  @if (eventData().timestamp) {
    <div class="mt-1">
      <span>
        @if (eventData().timezone) {
          {{ eventData().timestamp | dayjs: 'L LT' }} ({{ eventData().timezone }})
        } @else {
          {{ eventData().timestamp | dayjs: 'L LT' : true }}
        }
      </span>
    </div>
  }
</div>
